import { useState, useEffect } from 'react'
import axios from 'axios'

const API = process.env.REACT_APP_API_URL

const PESTANAS = [
  { id: 'clases',    etiqueta: '🧑‍🏫 Clases vistas',       unidad: 'clases' },
  { id: 'unidades',  etiqueta: '🎓 Unidades desarrolladas', unidad: 'unidades' },
  { id: 'juegos',    etiqueta: '🎮 Partidas jugadas',       unidad: 'partidas' },
  { id: 'insignias', etiqueta: '🏅 Insignias obtenidas',    unidad: 'insignias' }
]

const MEDALLAS = { 1: '🥇', 2: '🥈', 3: '🥉' }

function Tabla({ datos, usuarioId, unidad }) {
  const top = datos?.top || []

  if (!top.length) {
    return (
      <div style={{ textAlign: 'center', padding: '40px 20px', color: 'var(--gris-texto)', background: '#fff', border: '1px solid var(--gris-borde)', borderRadius: 16 }}>
        <div style={{ fontSize: 36, marginBottom: 8 }}>🏆</div>
        <p style={{ fontSize: 13 }}>Todavía no hay suficiente actividad para armar este ranking.</p>
      </div>
    )
  }

  const estoyEnElTop = top.some(f => f.usuario_id === usuarioId)

  return (
    <div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {top.map(f => {
          const soyYo = f.usuario_id === usuarioId
          return (
            <div key={f.usuario_id} style={{
              display: 'flex', alignItems: 'center', gap: 14,
              background: soyYo ? '#FEF3C7' : '#fff',
              border: '1.5px solid ' + (soyYo ? '#F59E0B' : 'var(--gris-borde)'),
              borderRadius: 14, padding: '12px 18px'
            }}>
              <div style={{ width: 32, textAlign: 'center', fontSize: MEDALLAS[f.posicion] ? 20 : 14, fontWeight: 800, color: 'var(--gris-texto)' }}>
                {MEDALLAS[f.posicion] || f.posicion}
              </div>
              <div style={{ fontSize: 22 }}>{f.avatar_emoji || '👤'}</div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 14, fontWeight: 700, color: soyYo ? '#92400E' : 'var(--negro)' }}>
                  {f.nombre_visible || 'Estudiante'}{soyYo ? ' (tú)' : ''}
                </div>
              </div>
              <div style={{ fontSize: 16, fontWeight: 800, color: 'var(--azul)' }}>{f.valor}</div>
            </div>
          )
        })}
      </div>

      {!estoyEnElTop && datos?.mi_posicion && (
        <div style={{ marginTop: 14, background: '#FEF3C7', border: '1.5px solid #F59E0B', borderRadius: 14, padding: '12px 18px', display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 32, textAlign: 'center', fontSize: 14, fontWeight: 800, color: '#92400E' }}>#{datos.mi_posicion}</div>
          <div style={{ flex: 1, fontSize: 13.5, fontWeight: 700, color: '#92400E' }}>Tu posición ({datos.mi_valor} {unidad})</div>
        </div>
      )}
    </div>
  )
}

/* Pagina de "Ranking": 4 tablas comparando a todos los
   estudiantes — clases vistas, unidades desarrolladas, partidas
   jugadas en EduNova Juegos e insignias obtenidas. */
export default function Ranking({ usuario }) {
  const [pestana,  setPestana]  = useState('clases')
  const [cargando, setCargando] = useState(true)
  const [datos,    setDatos]    = useState(null)
  const [error,    setError]    = useState(null)

  useEffect(() => {
    if (!usuario?.id) { setCargando(false); return }
    setCargando(true)
    axios.get(`${API}/ranking/${usuario.id}`).then(res => {
      setDatos(res.data)
    }).catch(err => {
      console.error('Error cargando ranking:', err)
      setError('No pudimos cargar el ranking. Intenta de nuevo.')
    }).finally(() => setCargando(false))
  }, [usuario])

  return (
    <div style={{ animation: 'fadeIn .3s ease both', maxWidth: 760 }}>
      <div style={{ background: 'linear-gradient(135deg,#92400E,#F59E0B)', borderRadius: 18, padding: '28px 30px', color: '#fff', marginBottom: 22 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ fontSize: 40 }}>🏆</span>
          <div>
            <h1 style={{ fontSize: 24, fontWeight: 800 }}>Ranking</h1>
            <p style={{ fontSize: 14, opacity: .9, marginTop: 4 }}>
              Compite con otros estudiantes de EnglishBridge.
            </p>
          </div>
        </div>
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', background: '#F0F2F8', border: '1px solid var(--gris-borde)', borderRadius: 10, overflow: 'hidden', marginBottom: 22 }}>
        {PESTANAS.map(p => (
          <button key={p.id} onClick={() => setPestana(p.id)}
            style={{ flex: '1 1 auto', minWidth: 150, padding: '9px 8px', border: 'none', background: pestana === p.id ? 'var(--azul)' : 'transparent',
              color: pestana === p.id ? '#fff' : 'var(--gris-texto)', fontFamily: 'inherit', fontSize: 12.5, fontWeight: 700, cursor: 'pointer' }}>
            {p.etiqueta}
          </button>
        ))}
      </div>

      {cargando && <div style={{ textAlign: 'center', padding: '50px 20px', color: 'var(--gris-texto)' }}>Cargando ranking...</div>}
      {error && <div style={{ background: '#FEE2E2', color: '#B91C1C', borderRadius: 10, padding: '10px 14px', fontSize: 13 }}>{error}</div>}

      {!cargando && !error && (
        <Tabla datos={datos?.[pestana]} usuarioId={usuario?.id} unidad={PESTANAS.find(p => p.id === pestana)?.unidad} />
      )}
    </div>
  )
}
